import type { AppProduct } from "@shared/interfaces/product";

/**
 * Placeholder product representing the "Keine Auswahl" (no selection) option.
 *
 * Kept in its own module so both ProductManager and the calculation services can
 * reference it without creating a circular import between them.
 */
export const nonProduct: AppProduct = {
    id: 0,
    name: "Keine Auswahl",
    description: "",
    price: 0,
} as AppProduct;
